import React from 'react';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps} from 'search/filters/base/FilterFormConstants';
import SecondaryFilterFormSkeleton from 'search/filters/base/SecondaryFilterFormSkeleton';
import {FilterKey, PartSequenceFilter, RnaPartSequenceFilter, SearchContext} from 'search/SearchConstants';
import ItemSearchInput, {Item} from 'ui-library/attach-dropdown/ItemSearchInput';
import {deprecatedSearchGet} from 'ui-library/inputs/ChipSearchInput';
import pickDefined from 'util/pickDefined';

export interface NucleotidePartSequenceFilterFormProps extends BaseFilterFormProps {
  filter: PartSequenceFilter | RnaPartSequenceFilter;
  onChangeFilter: (filter: PartSequenceFilter | RnaPartSequenceFilter) => void;
  onRemove: () => void;
}

export default function NucleotidePartSequenceFilterForm(
  props: NucleotidePartSequenceFilterFormProps
): JSX.Element {
  const searchInput = (
    <ItemSearchInput<Item>
      autoFocus={false}
      doSearch={deprecatedSearchGet}
      fetchParams={{context: SearchContext.LISTING}}
      itemKey="data"
      searchURL={`/1/api/all/search?filter=${props.filter.key === FilterKey.PART_SEQUENCE ? 'sequence' : 'rna_sequence'}`}
      shouldAllowMultiple={true}
      searchOnEmptyQuery={false}
      placeholder="Search by name"
      selectedItems={props.filter.value.map((id) => ({
        id,
      }))}
      onChange={(selectedItems: Array<Item>) => {
        props.onChangeFilter({
          ...props.filter,
          value: selectedItems.map((item) => item.id!),
        });
      }}
      disabled={props.locked}
    />
  );
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <SecondaryFilterFormSkeleton {...skeletonProps} nodeGrid={[[searchInput]]} onRemove={props.onRemove} />
  );
}
